import Page from "./Premier";

export default Page;
